export default "__VITE_PUBLIC_ASSET__1eac206b__"